import { UsStatesEnumType } from "@libs/api/patients";
import {
  AddressComponentType,
  AddressFieldsType,
} from "@/domain/householdMember";

export const parseAddressComponents = (
  addressComponents: AddressComponentType[],
): {
  streetOne: string | null;
  streetTwo: string | null;
  city: string | null;
  state: UsStatesEnumType | null;
  zip: string | null;
  county: string | null;
} => {
  if (!addressComponents || addressComponents.length === 0) {
    return {
      streetOne: null,
      streetTwo: null,
      city: null,
      state: null,
      zip: null,
      county: null,
    };
  }

  const getComponent = (types: string[]) => {
    return addressComponents.find(component =>
      types.some(type => component.types.includes(type)),
    );
  };

  const streetNumber = getComponent(["street_number"]);
  const route = getComponent(["route"]);
  const streetOne =
    [streetNumber?.long_name, route?.long_name]
      .filter(Boolean)
      .join(" ")
      .trim() || null;

  const subpremise = getComponent(["subpremise"]);
  const streetTwo = subpremise?.long_name ?? null;

  const locality = getComponent(["locality"]);
  const city = locality?.long_name ?? null;

  const administrativeArea = getComponent(["administrative_area_level_1"]);
  const state = (administrativeArea?.short_name as UsStatesEnumType) ?? null;

  const postalCode = getComponent(["postal_code"]);
  const zip = postalCode?.long_name ?? null;

  const countyComponent = getComponent(["administrative_area_level_2"]);
  const county = countyComponent?.short_name ?? null;

  return {
    streetOne,
    streetTwo,
    city,
    state,
    zip,
    county,
  };
};

export const formatAddress = (address: AddressFieldsType): string => {
  if (!address.streetOne) {
    return "";
  }

  const parts: string[] = [];

  const street = [address.streetOne, address.streetTwo].filter(Boolean);
  if (street.length > 0) {
    parts.push(street.join(" "));
  }
  if (address.city) {
    parts.push(address.city);
  }
  const stateZip = [address.state, address.zip].filter(Boolean);
  if (stateZip.length > 0) {
    parts.push(stateZip.join(" "));
  }
  parts.push(address.country ?? "USA");

  return parts.join(", ").trim();
};
